
<script setup lang="ts">
import { onBeforeUnmount, ref } from 'vue';
import Dropdown from '../components/Dropdown.vue';
import { Events } from '../events';

const {editor} = defineProps({
  editor: Object
})

enum TextKind {
  Heading1 = "Heading 1",
  Heading2 = "Heading 2",
  Heading3 = "Heading 3",
  Heading4 = "Heading 4",
  NormalText = "Normal Text",
}

const Headings = [
  TextKind.Heading1, TextKind.Heading2, TextKind.Heading3, TextKind.Heading4
]

const currentTextKind = ref(TextKind.NormalText)

const refreshText = Events.listen(Events.SELECTION, (e) => {

  const {editor} = e.detail

  if (!editor) {
    return;
  }

  const node = editor.state.selection.$head.node()

  if (node.type.name === 'heading') {    
    currentTextKind.value = Headings[node.attrs.level - 1] || TextKind.NormalText
  } else {
    currentTextKind.value = TextKind.NormalText    
  }

}) 

refreshText({ editor })

const listenGroup = Events.group()

onBeforeUnmount(() => {
  listenGroup.dispose();
})

</script>

<template>

  <Dropdown class="btn btn-xs btn-ghost whitespace-nowrap" btnWidth="85px" >        
    <template #button>
      {{ currentTextKind }}
    </template>    
    <template #content>
      <ul class="flex flex-col gap-1">
        <li class="selectable item" @click="editor.chain().focus().toggleHeading({ level: 1 }).run(); refreshText({ editor })">{{ TextKind.Heading1 }}</li>
        <li class="selectable item" @click="editor.chain().focus().toggleHeading({ level: 2 }).run(); refreshText({ editor })">{{ TextKind.Heading2 }}</li>
        <li class="selectable item" @click="editor.chain().focus().toggleHeading({ level: 3 }).run(); refreshText({ editor })">{{ TextKind.Heading3 }}</li>
        <li class="selectable item" @click="editor.chain().focus().toggleHeading({ level: 4 }).run(); refreshText({ editor })">{{ TextKind.Heading4 }}</li>
        <li class="selectable item" @click="editor.chain().focus().toggleNode('paragraph').run(); refreshText({ editor })">{{ TextKind.NormalText }}</li>
      </ul>
    </template>    
  </Dropdown>      

</template>

<style scoped lang="less">

</style>
